var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#085488",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.979 1.583h6.333V4.75H1.979zM1.979 14.25h6.333v3.167H1.979zM5.146 7.125v4.75M10.688 3.167h3.166V4.75M10.688 15.833h3.166V14.25M9.896 9.5l3.958-2.375L17.813 9.5l-3.959 2.375z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramBlue);
export default __webpack_public_path__ + "static/media/diagram-blue.d8ba6da8455e076d705c88645a3aeca7.svg";
export { ForwardRef as ReactComponent };